import './style.scss'

export function MessageCategory({ id, name, setSelected, selected, size = 0 }) {
  const isSelected = id === selected

  function handleSelect() {
    setSelected(id)
  }

  function renderSize() {
    if (!size) return null

    return <div className='size'>{size}</div>
  }

  return (
    <button
      type='button'
      className={`message-category ${isSelected ? '-selected' : ''}`}
      onClick={handleSelect}
    >
      <span className='label'>
        {name}
        {renderSize()}
      </span>
    </button>
  )
}
